const qa = {
  endpoint(method) {
    return `/qa/${method}`;
  },
  getTimeLogByDaySummary(internetUserId, payPeriodId) {
    return `/qa/${internetUserId}/payperiods/${payPeriodId}/summary`;
  },
  getPaySummary(internetUserId, payPeriodId) {
    return `/qa/${internetUserId}/paySummary/${payPeriodId}`;
  },
  get360Value(controlNumber) {
    return `/qa/${controlNumber}/360`;
  },
  getCaseAlerts() {
    return `/qa/case-alerts`;
  },
  getManagers() {
    return `/qa/managers`;
  },
  addTimeLog() {
    return `/qa/time-log`;
  },
  assignableUsers() {
    return `/qa/assignable-users`;
  },
};

export { qa };
